import { Dialog, DialogContent, Box, Typography, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "./scan-complete-dialog.scss";

interface Props {
  open: boolean;
  onClose: () => void;
  onVerifyLater: () => void;
  onViewDraft: () => void;
}

export default function ScanCompleteDialog({
  open,
  onClose,
  onVerifyLater,
  onViewDraft,
}: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      slotProps={{
        paper: {
          sx: {
            width: "470px",
            height: "367px",
            borderRadius: "28px",
            padding: "32px",
            textAlign: "center",
            borderTop: "6px solid #16a34a",
          },
        },
      }}
      classes={{ paper: "scan-dialog-paper" }}
    >
      <DialogContent className="scan-dialog-content">
        {/* Icon */}
        <Box className="success-icon">
          <CheckCircleIcon />
        </Box>

        {/* Title */}
        <Typography className="scan-title">Scanning Complete!</Typography>

        {/* Subtitle */}
        <Typography className="scan-subtitle">
          Business card details have been converted to a draft lead. Verify the
          details to convert to a published lead.
        </Typography>

        {/* Buttons */}
        <Box className="scan-actions">
          <Button
            variant="outlined"
            className="verify-btn"
            onClick={onVerifyLater}
            sx={{
              textTransform: "none",
            }}
          >
            Verify Later
          </Button>

          <Button
            variant="contained"
            className="view-btn"
            onClick={onViewDraft}
            sx={{
              textTransform: "none",
            }}
          >
            View Draft
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
